import script from "./Achievements.vue?vue&type=script&setup=true&lang=js"
export * from "./Achievements.vue?vue&type=script&setup=true&lang=js"

import "./Achievements.vue?vue&type=style&index=0&id=2e94e31a&lang=scss"

const __exports__ = script;

export default __exports__